export const mainEn = {
    sousuo:"search",
    placeholder:"please enter the keyword",
    fuwuliucheng:"Service process",
    fuwushenqing:"Service application",
    huoqubaojia:"Get quotes",
    hetongqianding:"The contract signing",
    chanpingjiance:"Product testing",
    zaixianfazheng:"Online certification",
    diquguojia:"region",
    ziliaowenku:"Please select information type",
    ziliaowenk:"The data library",
    xinxileixing:"Information",
    qzxcprz:"Mandatory product certification",
    faburiqi:"Release date",
    xuanzeriqi:"Select a date",
    jcrzsjzx:"Test the certification data center",
    rzjgzhcx:"Comprehensive query of certification results",
    zssy:"Certificate of traceability",
    jcjgxx:"Detection mechanism information",
    rzgzcx:"Authentication rule query",
    rzbzcx:"Certification standard query",
    cyzgcx:"Certificate number：",
    zsbh:"Certificate number",
    hzzzmc:"Certificate name：",
    rzxm:"Certification program：",
    qingxuanze:"Please select",
    zszt:"Certificate status：",
    zszt1:"Certificate status",
    rkzt:"Approval mark：",
    pxfu:"Training services",
    bofangpaihang:"Play out",
    zhuanjiazixun:"Expert advice",
    hezuojigou:"Cooperation agency",
    jiancerenzxgj:"test and certify small tools",
    hzzzbh:'Name of licensed organization',
    qsrzsbh:'please enter certificate number',
    qsrzsmc:'Please enter the certificate name',
    dingdbh:'Order number',
    sangpmc:'Commodity name',
    cjzxm:'Creator name',
    guojiabiaozunchaxun:'National standard inquiry',
    shipingshujukuchaxun:"Food database query",
    shengqingqiyeztmc:'Name of applicant'
}


// WEBPACK FOOTER //
// ./src/lang/home/main/mainEn.js